import React from 'react';
import { clsx } from 'clsx';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  background?: 'default' | 'white' | 'blush';
}
export function Section({
  children,
  className,
  id,
  background = 'default'
}: SectionProps) {
  const backgrounds = {
    default: 'bg-brand-bg',
    white: 'bg-white',
    blush: 'bg-brand-secondary/10'
  };
  return <section id={id} className={clsx('py-10 md:py-14 px-4 md:px-8', backgrounds[background], className)} data-id="element-283">
      <div className="max-w-7xl mx-auto w-full" data-id="element-284">{children}</div>
    </section>;
}